import { SETTINGS_KEY } from '@/constants';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AppSettings {
  /** 暗色模式 */
  dark: boolean;
  /** 侧边栏折叠 */
  collapsed: boolean;
}

const DEFAULT_SETTINGS: AppSettings = {
  dark: false,
  collapsed: false,
};

interface AppState extends AppSettings {
  updateSettings: (patch: Partial<AppSettings>) => void;
  toggleDark: () => void;
  toggleCollapsed: () => void;
}

/** 全局设置（暗色模式 / 菜单折叠），persist 到 localStorage */
export const useAppStore = create<AppState>()(
  persist(
    (set, get) => ({
      ...DEFAULT_SETTINGS,
      updateSettings: (patch) => set(patch),
      toggleDark: () => set({ dark: !get().dark }),
      toggleCollapsed: () => set({ collapsed: !get().collapsed }),
    }),
    {
      name: SETTINGS_KEY,
      // dark 不持久化：暗色入口已隐藏，同时忽略历史数据里的 dark，
      // 避免旧的 dark: true 残留导致界面变暗又没有开关可以切回
      partialize: ({ collapsed }) => ({
        collapsed,
      }),
      merge: (persisted, current) => ({
        ...current,
        ...(persisted as Partial<AppState>),
        dark: false,
      }),
    },
  ),
);

// 注意：不要再导出 `useAppStore()` 的全量 hook——那样任何一项设置变化都会
// 让所有使用方重渲染。组件里请按字段订阅：useAppStore((s) => s.collapsed)
